import { useState } from "react"
import { Copy, Check } from "lucide-react"
import { Button } from "@/components/ui/button"
import { useToast } from "@/hooks/useToast"
import { cn } from "@/lib/utils"

interface CopyButtonProps {
  text: string
  variant?: "ghost" | "default" | "outline" | "secondary"
  size?: "default" | "sm" | "lg" | "icon" | "xs"
  className?: string
  iconClassName?: string
  tooltip?: string
  onCopy?: () => void
}

export function CopyButton({
  text,
  variant = "ghost",
  size = "icon",
  className,
  iconClassName,
  tooltip = "Copy",
  onCopy,
}: CopyButtonProps) {
  const [copied, setCopied] = useState(false)
  const { toast } = useToast()

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text)
      setCopied(true)
      onCopy?.()
      setTimeout(() => {
        setCopied(false)
      }, 2000)
    } catch (err) {
      console.error("Failed to copy to clipboard:", err)
      toast({
        description: "Failed to copy to clipboard.",
        variant: "destructive",
      })
    }
  }

  return (
    <Button variant={variant} size={size} onClick={handleCopy} className={className} tooltip={tooltip}>
      {copied ? (
        <Check className={cn("h-4 w-4 text-green-600 dark:text-green-400", iconClassName)} />
      ) : (
        <Copy className={cn("h-4 w-4 text-gray-500 dark:text-gray-400", iconClassName)} />
      )}
    </Button>
  )
}
